export const convertDateToUTC = (date) => {
  if (!date) {
    return null;
  }

  const originalDate = new Date(date);
  if (originalDate.getUTCHours() !== 0) {
    const convertedDate = new Date(originalDate.getTime() - originalDate.getTimezoneOffset() * 60000);
    return convertedDate.toISOString();
  }
  return originalDate.toISOString();
};

// Used in the popperModifiers prop of the DatePicker
// component (react-datepicker) to force the popper to
// always open below the input
export const DATE_PICKER_POPPER_MODIFIERS = {
  flip: {
    behavior: ['bottom'],
  },
  preventOverflow: {
    enabled: false,
  },
  hide: {
    enabled: false,
  },
};

export const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

export const sameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

export const parseYMD = (ymd) => {
  if (!ymd || typeof ymd !== 'string') return null;
  const [y, m, d] = ymd.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

export const parseWindow = (windowStr) => {
  if (!windowStr || typeof windowStr !== 'string') return { start: null, end: null };

  const parts = windowStr.split(' - ').map((s) => s.trim());
  if (parts.length !== 2) return { start: null, end: null };

  return {
    start: parseYMD(parts[0]),
    end: parseYMD(parts[1]),
  };
};

export const isWithinInclusive = (date, start, end) => {
  if (!date || !start || !end) return false;

  const d = startOfDay(date).getTime();
  const s = startOfDay(start).getTime();
  const e = startOfDay(end).getTime();

  return d >= s && d <= e;
};
